import React from 'react';
import { useTheme } from 'styled-components';
import { InterUIIcon } from '../../core';
import { IInterUIBabiProps } from '../../interfaces/inter-ui-babi-props';
import {
  BabiContainer,
  Text,
  WrapperIcon,
  WrapperImg,
  WrapperText
} from './InterUIBabi.styles';

export const BABI_IMG_CDN =
  'https://static.bancointer.com.br/inter-ui/assets/babi-avatar-new.png';

export const InterUIBabi: React.FC<IInterUIBabiProps> = ({
  title,
  subTitle,
  image,
  onClick
}) => {
  const theme = useTheme();

  return (
    <BabiContainer onClick={onClick} data-testid='babi'>
      <WrapperImg>
        <img src={image ?? BABI_IMG_CDN} alt='imagem babi' />
      </WrapperImg>

      <WrapperText>
        <Text
          color={theme.colors.neutral.grayscale.A500}
          fontWeight='700'
          fontSize='0.875rem'
        >
          {title}
        </Text>
        <Text
          color={theme.colors.neutral.grayscale.A400}
          fontWeight='400'
          fontSize='0.75'
        >
          {subTitle}
        </Text>
      </WrapperText>

      <WrapperIcon>
        <InterUIIcon
          name='arrow-chevron-right'
          size='md'
          color={theme.colors.primary.A500}
        />
      </WrapperIcon>
    </BabiContainer>
  );
};

InterUIBabi.defaultProps = {
  title: 'Precisa de ajuda?',
  subTitle: 'Converse com a gente pelo chat. A Babi vai te ajudar.'
};
